<template>
	<div class="input-container">
		<input
			type="text"
			v-model="dataValue"
			@keyup.enter="handleSubmit"
			:placeholder="placeholder"
			class="input-field"
		/>
		<i
			class="icon icon-arrow-right-circle"
			@click="handleSubmit"
			:disabled="isLoading"
		></i>
	</div>
</template>

<script>
import { LOADING } from '@/store/modules/chat/chat-mutation-types';
import { mapGetters } from 'vuex';
export default {
	name: 'VueChatInput',
	model: {
		prop: 'value',
		event: 'submit'
	},
	props: {
		value: {
			type: [String],
			default: ''
		},
		placeholder: {
			type: String,
			default: 'Send a message'
		}
	},
	data() {
		return {
			dataValue: ''
		};
	},
	computed: {
		...mapGetters('chat', {
			isLoading: [LOADING]
		})
	},
	methods: {
		handleSubmit() {
			if (this.dataValue.trim() && !this[LOADING]) {
				this.$emit('submit', this.dataValue);
				this.dataValue = '';
			}
		}
	},
	watch: {
		value: {
			immediate: true,
			handler(val) {
				this.dataValue = val;
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.input-container {
	display: flex;
	align-items: center;
	gap: 8px;
	padding: 8px;
	border: 1px solid #ccc;
	border-radius: $border-radius;
	position: relative;
}

.input-field {
	flex: 1;
	border: none;
	outline: none;
	font-size: $txt-font-size;
}

.input-icon {
	position: absolute;
	right: 10px;
	cursor: pointer;
	font-size: 20px;
	color: #007bff;
}

.input-icon:hover {
	color: #0056b3;
}
</style>
